import { Box, Text } from '@backstage/ui';
import styles from './badges.module.css';

const apiTypeClassMap: Record<string, string> = {
  openapi: styles.apiOpenapi,
  grpc: styles.apiGrpc,
  asyncapi: styles.apiAsyncapi,
  graphql: styles.apiGraphql,
};

export const ApiTypeBadge = ({ type }: { type: string }) => {
  const variantClass = apiTypeClassMap[type.toLowerCase()] || styles.apiDefault;
  return (
    <Box className={`${styles.badge} ${variantClass}`}>
      <Text variant="body-x-small">{type}</Text>
    </Box>
  );
};
